<div class="m-0 p-0">
    <div class="dv-label strong" style="margin: 0;padding: 0;">
        Alternative Emails
    </div>
    <div *ngFor="let item of value; let i = index;">
        <resident-email-field
            class="col-sm-12" style="margin: 0;padding: 0;"
            #alternativeEmails
            [icon]="'fa fa-envelope'"
            [canDeleteEmail]="true"
            [ngModel]="item.email"
            [invalidEmail]="item.isBadEmail != undefiled && item.isBadEmail"
            [editMode]="value.length - 1 == i && item.email == '' && !item.isBadEmail" 
            (update)="onSubmit(alternativeEmails, i)"
            (canceled)="onCanceled(i)"
            (deleteEmail)="onDelete($event)">
        </resident-email-field>
    </div>
    <spinner [spinnerShow]="value?.length && value[0].email == undefined"></spinner>
</div>

<div *ngIf="!noEdit" class="row">
    <div class="col-sm-12">
        <i class="icon-plus pull-right" (click)="addNew()" id="add-new-phone"
           data-toggle="tooltip" data-placement="top" title="Add New Phone"></i>
    </div>
</div>


// WEBPACK FOOTER //
// /app/src/app/components/fields/resident-alternative-emails-field/resident-alternative-emails-field.template.html